import { InfoCircleOutlined } from '@ant-design/icons';
import React from 'react';

const quarters = ['Q1 2025', 'Q2 2025', 'Q3 2025', 'Q4 2025'];
const before = [[52, 48, 37], [65, 57, 45], [69, 62, 46], [74, 81, 56]];
const after = [[33, 19, 18], [39, 21, 20], [41, 23, 22], [44, 24, 22]];

const Chart: React.FC<{ mode: 'grouped' | 'stacked' }> = ({ mode }) => {
  const data = mode === 'grouped' ? before : after;
  return (
    <div className={`demo-chart ${mode}`} aria-label={`${mode} Revenue by Region chart`}>
      <div className="chart-grid-lines"><span /><span /><span /><span /></div>
      <div className="chart-y-label">Revenue ($M)</div>
      <div className="chart-plot">
        {data.map((values, index) => (
          <div className="chart-quarter" key={quarters[index]}>
            <div className="chart-bars">
              {values.map((value, series) => <span key={series} className={`bar series-${series}`} style={{ height: `${value * 1.75}px` }} />)}
            </div>
            <span className="quarter-label">{quarters[index]}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export const VisualDiffCard: React.FC = () => (
  <section className="visual-diff-card">
    <div className="visual-pane">
      <h2>Before · GitHub main</h2>
      <h3>Revenue by Region</h3>
      <p>Bar chart</p>
      <div className="chart-legend"><span className="legend-a" />Americas <span className="legend-b" />EMEA <span className="legend-c" />APAC</div>
      <Chart mode="grouped" />
    </div>
    <div className="visual-pane">
      <h2>After · Current Qlik App</h2>
      <h3>Revenue by Region</h3>
      <p>Bar chart (stacked)</p>
      <div className="chart-legend"><span className="legend-a" />Americas <span className="legend-b" />EMEA <span className="legend-c" />APAC</div>
      <Chart mode="stacked" />
    </div>
    <div className="capability-note"><InfoCircleOutlined /> Rendered with Qlik Capability API from the same object using before and after properties.</div>
  </section>
);

